import { AlertCircle, LoaderCircle } from "lucide-react";

export function LoadingState({ label = "Đang tải dữ liệu..." }: { label?: string }) {
  return (
    <div className="page-state">
      <LoaderCircle className="spin" size={30} />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <div className="page-state error-state">
      <AlertCircle size={30} />
      <strong>Chưa thể tải dữ liệu</strong>
      <span>{message}</span>
      {retry && (
        <button className="secondary-button" onClick={retry}>
          Thử lại
        </button>
      )}
    </div>
  );
}
